import $http from "../axios";
import i18n from "../i18n";
import XLSX from "xlsx-js-style";

const actions = {
  getRefillsStock(_, data) {
    return $http.get("product-logs", { params: data });
  },

  downloadRefillsStockReport(_, data) {
    const rows = data.refillsStock.map(item => ({
      ID: item.id,
      [i18n.t("refillsStock.date")]: item.createdAt,
      [i18n.t("refillsStock.user")]: item.userName,
      [i18n.t("refillsStock.operation")]: item.operation,
      [i18n.t("refillsStock.status")]: item.status,
      [i18n.t("refillsStock.quantity")]: item.quantity,
      [i18n.t("refillsStock.quantityBefore")]: item.quantityBefore,
      [i18n.t("refillsStock.quantityAfter")]: item.quantityAfter
    }));
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      data.productName || "SKU"
    );
    XLSX.writeFile(workbook, `${i18n.t("refillsStock.reportFilename")}.xlsx`);
    return Promise.resolve();
  }
};

export default { actions };
